import { Tag } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { CountdownTimer } from "@/components/social-proof/CountdownTimer";
import { useActivePromo } from "@/hooks/useActivePromo";

export const PromoBanner = () => {
  const { promo, isLoading, expiresAt } = useActivePromo();

  // Don't show if loading, no active promo, or promo is expired
  if (isLoading) return null;
  if (!promo || !expiresAt) return null;
  
  // Check if promo is expired
  const now = new Date();
  if (expiresAt.getTime() <= now.getTime()) return null;

  // Parse the discount value
  const discountValue = Math.abs(parseFloat(promo.value));
  const discountDisplay = promo.valueType === 'percentage' ? `${discountValue}%` : `$${discountValue}`;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "auto", opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        className="fixed top-0 left-0 right-0 z-[60] bg-foreground text-background"
      >
        <div className="container-calim py-2">
          <div className="flex items-center justify-center gap-2 sm:gap-4 text-xs sm:text-sm">
            <div className="flex items-center gap-1.5 sm:gap-2">
              <Tag className="h-3 sm:h-4 w-3 sm:w-4 flex-shrink-0" />
              <span className="font-medium whitespace-nowrap">
                🎉 <strong>-{discountDisplay}</strong> with{" "}
                <span className="inline-flex items-center px-1 sm:px-2 py-0.5 rounded bg-background/20 font-mono font-bold tracking-wider text-[10px] sm:text-xs">
                  {promo.code}
                </span>
              </span>
            </div>
            <div className="hidden sm:block w-px h-4 bg-background/30" />
            <div className="hidden sm:block">
              <CountdownTimer />
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
